
import { cn } from "../lib/utils";

export function Divider( { className } ) {

  return <div aria-hidden="true" className={ cn( "border-t-[1.5px] border-grey-smoke w-full", className ) } />

}
